<ion-tabs>
  <ion-tab-bar *ngIf="showTabs" slot="bottom">
    <ion-tab-button [routerLink]="['/dashboard']" routerDirection="root" [class.tab-selected]="isActive('/dashboard')">
      <i class="fa fa-home"></i>
      {{ 'menu.dashboard_mobile' | i18n }}
    </ion-tab-button>
    <ion-tab-button [routerLink]="['/taskSelection']" routerDirection="root" [class.tab-selected]="isActive('/taskSelection')">
      <ion-icon src="assets/icon/task-icon.svg" aria-hidden="true"></ion-icon>
      {{ 'menu.tasks_taskSelection' | i18n }}
    </ion-tab-button>

    <ion-tab-button></ion-tab-button>
    <ion-tab-button [routerLink]="['/farmSelection']" routerDirection="root" [class.tab-selected]="isActive('/farmSelection')">
      <i class="fa fa-pagelines"></i>
      {{ 'menu.farms_farmSelection' | i18n }}
    </ion-tab-button>
    <ion-tab-button [routerLink]="['/accountMobile']" routerDirection="root" [class.tab-selected]="isActive('/accountMobile')">
      <i class="fa fa-user"></i>
      {{ 'menu.userSettings_accountMobile' | i18n }}
    </ion-tab-button>
  </ion-tab-bar>
</ion-tabs>

<ion-fab *ngIf="showTabs" vertical="bottom" horizontal="center" slot="fixed" edge="false">
  <ion-fab-button (click)="fabOpen = !fabOpen" class="main-fab">
    <i [class]="fabOpen ? 'bi bi-x-lg' : 'bi bi-grid-fill'"></i>
  </ion-fab-button>

  <div class="fab-horizontal-menu" [class.open]="fabOpen">
    <ion-button
      *ngFor="let item of menuList; let i = index"
      class="fab-menu-item"
      shape="round"
      [style.--item-delay.ms]="i * 50"
      (click)="navigateToCart(item.route)"
    >
      <ng-container *ngIf="isSvgIcon(item.iconName); else fontIcon">
        <ion-icon class="fab-menu-icon" [src]="item.iconName" aria-hidden="true"></ion-icon>
      </ng-container>
      <ng-template #fontIcon>
        <i [class]="item.iconName"></i>
      </ng-template>
    </ion-button>
  </div>
</ion-fab>
